import React, { Component } from 'react'
import './Settings.css'
import FormElement from '../../common/formComponents/FormElement'
import { Legend } from '../../common/formComponents/additionalComponents'
import Form from '../../common/formComponents/Form'
import withPolyglot from '../../common/withPolyglot'

class Settings extends Component {
  handleSubmit (content) {
    this.props.changeLanguage(content.language)
  }
  render () {
    const {currentLocale} = this.props
    return <div className='settings-container'>
      <Form handleSubmit={this.handleSubmit.bind(this)}>
        <Legend content={this.props.translate('general')} />
        <FormElement
          type={'select'}
          label={this.props.translate('languageSelect')}
          name={'language'}
          options={[
            {
              value: 'en',
              displayValue: 'English'
            },
            {
              value: 'pt',
              displayValue: 'Português (Portugal)'
            },
            {
              value: 'br',
              displayValue: 'Português (Brasil)'
            },
            {
              value: 'de',
              displayValue: 'Deutch'
            }
          ]}
          defaultValue={currentLocale} />
        <button className='uk-button uk-button-primary uk-float-right'>{this.props.translate('save')}</button>
      </Form>
    </div>
  }
}

export default withPolyglot(Settings, 'settings')
